export default {"src":"/_next/static/media/idtheft.d16b119d.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};